import { render, staticRenderFns } from "./ListaSujaTrabalhoEscravo.vue?vue&type=template&id=621d2158&lang=pug"
import script from "./ListaSujaTrabalhoEscravo.vue?vue&type=script&lang=js"
export * from "./ListaSujaTrabalhoEscravo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports